
import { KpiCardType } from './types';

// Helper functions for the dashboard context
export const reorderCards = (cards: KpiCardType[], draggedId: string, targetId: string): KpiCardType[] => {
  const draggedIndex = cards.findIndex(card => card.id === draggedId);
  const targetIndex = cards.findIndex(card => card.id === targetId);
  
  if (draggedIndex === -1 || targetIndex === -1) {
    console.log(`Could not find one or both cards: dragged (${draggedId}), target (${targetId})`);
    return cards;
  }
  
  // Create a deep copy of the cards array
  const newCards = cards.map(card => ({ ...card }));
  
  // Get the order values of the dragged and target cards
  const draggedOrder = newCards[draggedIndex].order;
  const targetOrder = newCards[targetIndex].order;
  
  console.log(`Swapping orders: Card ${draggedId} (order ${draggedOrder}) with Card ${targetId} (order ${targetOrder})`);
  
  // Simply swap the order values between the dragged and target cards
  newCards[draggedIndex].order = targetOrder;
  newCards[targetIndex].order = draggedOrder;
  
  // Sort the cards by their order
  return newCards.sort((a, b) => a.order - b.order);
};
